<div class="row">
  <div class="col-lg-3">
    <nav class="navbar navbar-expand-md navbar-light d-none d-lg-block">
      <ul class="nav flex-column">
        @for (tab of tabs; track tab) {
          @if (!tab.show || tab.show(storageService.role)) {
            <li class="nav-item" [class.active]="selectedTab === tab.route">
              <a class="nav-link" [routerLink]="tab.route" (click)="changeTab(tab.route)">{{
                tab.name | translate
              }}</a>
            </li>
          }
        }
      </ul>
    </nav>
    <div class="dropdown" ngbDropdown>
      <i class="no-caret fa fa-bars d-lg-none" ngbDropdownToggle></i>
      <div class="dropdown-menu" ngbDropdownMenu>
        @for (tab of tabs; track tab) {
          @if (!tab.show || tab.show(storageService.role)) {
            <div [routerLink]="tab.route" (click)="changeTab(tab.route)" class="dropdown-item">
              {{ tab.name | translate }}
            </div>
          }
        }
      </div>
    </div>
  </div>
  <div class="col-lg-9">
    <router-outlet></router-outlet>
  </div>
</div>
